export const rangeWeaponList = [
  {
    technik: "Armbrüste",
    lade: "2 Akt.",
    grundschaden: "1W6",
    bonus: "+4",
    reichweite: {nah: 5, mittel: 25, weit: 40},
    munition: "Kugeln",
    gewicht: "0,75 Stn",
    name: "Balestrina",
    preis: "120",
    bf: "6",
  },
  {
    technik: "Armbrüste",
    lade: "2/10 Akt.",
    grundschaden: "1W6",
    bonus: "+4",
    reichweite: {nah: 10, mittel: 50, weit: 80},
    munition: "Bolzen",
    gewicht: "3,75 Stn",
    name: "Eisenwalder",
    preis: "500",
    bf: "6",
  },
  {
    technik: "Armbrüste",
    lade: "3 Akt.",
    grundschaden: "1W6",
    bonus: "+3",
    reichweite: {nah: 5, mittel: 25, weit: 40},
    munition: "Bolzen",
    gewicht: "0,75 Stn",
    name: "Handarmbrust",
    preis: "100",
    bf: "6",
  },
  {
    technik: "Armbrüste",
    lade: "8 Akt.",
    grundschaden: "1W6",
    bonus: "+6",
    reichweite: {nah: 10, mittel: 50, weit: 80},
    munition: "Bolzen",
    gewicht: "3,25 Stn",
    name: "leichte Armbrust",
    preis: "180",
    bf: "6",
  },
  {
    technik: "Armbrüste",
    lade: "15 Akt.",
    grundschaden: "2W6+6",
    bonus: "",
    reichweite: {nah: 20, mittel: 100, weit: 160},
    munition: "Bolzen",
    gewicht: "7,25 Stn",
    name: "schwere Armbrust",
    preis: "360",
    bf: "6",
  },
  {
    technik: "Bögen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+5",
    reichweite: {nah: 50, mittel: 100, weit: 200},
    munition: "Pfeile",
    gewicht: "0,5 Stn",
    name: "Elfenbogen",
    preis: "400",
    bf: "4",
  },
  {
    technik: "Bögen",
    lade: "2 Akt",
    grundschaden: "1W6",
    bonus: "+7",
    reichweite: {nah: 20, mittel: 100, weit: 160},
    munition: "Pfeile",
    gewicht: "0,75 Stn",
    name: "Kompositbogen",
    preis: "160",
    bf: "4",
  },
  {
    technik: "Bögen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+4",
    reichweite: {nah: 10, mittel: 50, weit: 80},
    munition: "Pfeile",
    gewicht: "0,5 Stn",
    name: "Kurzbogen",
    preis: "45",
    bf: "4",
  },
  {
    technik: "Bögen",
    lade: "2 Akt",
    grundschaden: "1W6",
    bonus: "+8",
    reichweite: {nah: 20, mittel: 100, weit: 160},
    munition: "Pfeile",
    gewicht: "0,75 Stn",
    name: "Langbogen",
    preis: "80",
    bf: "4",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+4",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "1 Stn",
    name: "Schneidzahn",
    preis: "80",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "1 Stn",
    name: "Stein",
    preis: "0",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+3",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "0,75 Stn",
    name: "Wurfbeil",
    preis: "50",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+1",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "0,5 Stn",
    name: "Wurfdolch",
    preis: "45",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+2",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "1 Stn",
    name: "Wurfkeule",
    preis: "5",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+1",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "0,25 Stn",
    name: "Wurfring",
    preis: "30",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+1",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "0,25 Stn",
    name: "Wurfscheibe",
    preis: "30",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+1",
    reichweite: {nah: 2, mittel: 10, weit: 15},
    munition: "",
    gewicht: "0,25 Stn",
    name: "Wurfstern",
    preis: "30",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "2 Akt",
    grundschaden: "2W6+2",
    bonus: "",
    reichweite: {nah: 5, mittel: 25, weit: 40},
    munition: "",
    gewicht: "0,75 Stn",
    name: "Wurfspeer",
    preis: "40",
    bf: "10",
  },
  {
    technik: "Bögen",
    lade: "2 Akt",
    grundschaden: "1W6",
    bonus: "+8",
    reichweite: {nah: 20, mittel: 120, weit: 180},
    munition: "Pfeile",
    gewicht: "1 Stn",
    name: "Nostrischer Langbogen",
    preis: "100",
    bf: "4",
  },
  {
    technik: "Feuerspeien",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "",
    reichweite: {nah: 1, mittel: 2, weit: 3},
    munition: "speziell",
    gewicht: "0 Stn",
    name: "Feuerspeien",
    preis: "0",
    bf: "-",
  },
  {
    technik: "Schleudern",
    lade: "2 Akt",
    grundschaden: "1W6",
    bonus: "+2",
    reichweite: {nah: 5, mittel: 25, weit: 60},
    munition: "Steinchen",
    gewicht: "0,25 Stn",
    name: "Schleuder",
    preis: "5",
    bf: "4",
  },
  {
    technik: "Armbrüste",
    lade: "2 Akt.",
    grundschaden: "1W6",
    bonus: "+3",
    reichweite: {nah: 20, mittel: 60, weit: 100},
    munition: "Kugeln",
    gewicht: "3 Stn",
    name: "Balläster",
    preis: "200",
    bf: "6",
  },
  {
    technik: "Blasrohre",
    lade: "2 Akt.",
    grundschaden: "1W2",
    bonus: "",
    reichweite: {nah: 5, mittel: 20, weit: 40},
    munition: "Blasrohrpfeile",
    gewicht: "0,5 Stn",
    name: "Blasrohr",
    preis: "40",
    bf: "10",
  },
  {
    technik: "Diskusse",
    lade: "2 Akt.",
    grundschaden: "1W6",
    bonus: "+2",
    reichweite: {nah: 5, mittel: 25, weit: 40},
    munition: "",
    gewicht: "0,75 Stn",
    name: "Diskus",
    preis: "25",
    bf: "12",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt.",
    grundschaden: "spez.",
    bonus: "",
    reichweite: {nah: 1, mittel: 3, weit: 5},
    munition: "",
    gewicht: "2 Stn",
    name: "Wurfnetz",
    preis: "35",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W3",
    bonus: "",
    reichweite: {nah: 2, mittel: 4, weit: 8},
    munition: "",
    gewicht: "",
    name: "Apfel",
    preis: "0",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W3",
    bonus: "",
    reichweite: {nah: 2, mittel: 4, weit: 8},
    munition: "",
    gewicht: "",
    name: "Steinchen",
    preis: "0",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W3",
    bonus: "+1",
    reichweite: {nah: 2, mittel: 4, weit: 8},
    munition: "",
    gewicht: "",
    name: "Bierkrug",
    preis: "",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W3",
    bonus: "+1",
    reichweite: {nah: 2, mittel: 4, weit: 8},
    munition: "",
    gewicht: "",
    name: "Geschirr",
    preis: "",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W3",
    bonus: "+1",
    reichweite: {nah: 2, mittel: 4, weit: 8},
    munition: "",
    gewicht: "2 Stn",
    name: "Vase",
    preis: "1",
    bf: "10",
  },
  {
    technik: "Wurfwaffen",
    lade: "1 Akt",
    grundschaden: "1W6",
    bonus: "+1",
    reichweite: {nah: 3, mittel: 6, weit: 9},
    munition: "",
    gewicht: "2 Stn",
    name: "Zauberkugel",
    preis: "30",
    bf: "10",
  }
];



// WEBPACK FOOTER //
// ./src/range-list.jsx